import React from 'react';
import isEmpty        from "lodash.isempty";
import moment from "moment";

const getValidUrl = (url = "") => {
    let newUrl = window.decodeURIComponent(url);
    newUrl = newUrl.trim().replace(/\s/g, "");

    if(/^(:\/\/)/.test(newUrl)){
      return `http${newUrl}`;
    }
    if(!/^(f|ht)tps?:\/\//i.test(newUrl)){
        return `http://${newUrl}`;
      }

      return newUrl;
    }

const AdsBanner = () =>{
	  let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
	  let userTypeName = localStorage.getItem("userTypeName");
	  let defaultStyle;

	  let bannersRow;
	  let bannersListData = (siteData && siteData.adsBannersData)
	  ? siteData.adsBannersData
	  : [];

	  if((userTypeName == 'merchant' && bannersListData.displayMerchant == '0') || (userTypeName == 'subadmin' && bannersListData.displaySubadmin == '0')){
        defaultStyle = {display: 'none' } 
      }else{
        defaultStyle = {display: 'block' } 
      }

      if (!isEmpty(bannersListData) && siteData.adsActive == 'Active') {
        bannersRow = (
          <div  key={bannersListData.bannersID} className="active_banners" style={defaultStyle}>
            <a href={getValidUrl(bannersListData.banner_image_link)} target="_blank"><img src={bannersListData.banner_image} style={{width: 'auto',maxHeight: '200px'}}/></a>
            <div className="banner_date">
              <span className="banners_start">
                {(bannersListData.start_date) ? moment(bannersListData.start_date).format("ll") : ""}
              </span>
              <span> - </span>
              <span className="banners_end">
                {(bannersListData.end_date) ? moment(bannersListData.end_date).format("ll") : ""}
              </span>
            </div>
          </div>
        );
      }

	return(
		<React.Fragment>
			{bannersRow}
		</React.Fragment>
	)
};

export default AdsBanner;      


// WEBPACK FOOTER //
// ./src/app/components/aside/asideRight/AdsBanner.js